import get from "lodash/get";

import { DPD_DIRECT_SERVICE } from "~/constants/strings";

import * as routes from "./constants";
import { convertToBool } from "~/models/normolizers/normalizers";
import {
  BULK_PATH,
  GROUP_DISPATCH_PATH,
  TOOLS_MENU_PATH,
} from "~/pages/Tools/constants";

export const isRestrictedTab = (settings, tabName) => {
  const disableAdhocEditShipment = !!get(
    settings,
    "securitySettings.disableAdhocEditShipment",
    false
  );

  const disableContainerTab = !get(
    settings,
    "customerServices.services",
    []
  ).includes(DPD_DIRECT_SERVICE);

  if (tabName === routes.CREATE) {
    return disableAdhocEditShipment;
  }

  // @see https://it.dpduk.live/version/customer-shipping/sprint-2.10/diag_P4UctkGGAqCIeGQ_.html?id=1671540247392
  if (tabName === routes.SCANNING) {
    return (
      !get(settings, "shippingSettings.enableScanningScreen", false) ||
      disableAdhocEditShipment
    );
  }

  if (tabName === routes.CONTAINER) {
    return disableContainerTab;
  }

  if (
    tabName === routes.TOOLS ||
    tabName === GROUP_DISPATCH_PATH ||
    tabName === TOOLS_MENU_PATH
  ) {
    return !convertToBool(process.env.REACT_APP_FEATURE_GROUP_DISPATCH);
  }

  if (tabName === routes.TOOLS || tabName === BULK_PATH) {
    return !(
      convertToBool(process.env.REACT_APP_FEATURE_GROUP_DISPATCH) &&
      get(settings, "shippingSettings.enableBulkRev", false)
    );
  }

  return (
    (tabName === routes.FAILED_IMPORTS ||
      tabName === routes.FAILED_IMPORT_EDIT) &&
    !get(settings, "shippingSettings.onScreenImportFix", false)
  );
};
